import { render } from "./App.vue?vue&type=template&id=8401e896"
import script from "./App.js?vue&type=script&lang=js"
export * from "./App.js?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=8401e896&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__